module.exports = __webpack_public_path__ + "static/media/Happy.df007a0f.png";